import { getCurrentUser, fetchUserAttributes } from "aws-amplify/auth";

export const logout = async (): Promise<void> => {
  localStorage.clear();

  const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN;
  const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
  const redirectUri = import.meta.env.VITE_COGNITO_REDIRECT_SIGN_IN;

  // Construct logout URL dynamically
  const logoutUrl = `https://${cognitoDomain}/logout?client_id=${clientId}&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+profile&redirect_uri=${redirectUri}`;

  globalThis.location?.assign?.(logoutUrl);
};

export type LoggedInUser = {
  userId: string;
  username: string;
  name: string;
  email?: string;
  customRole?: string;
  mspId?: number;
};

export const getLoggedInUser = async (): Promise<LoggedInUser | null> => {
  try {
    const currentUser = await getCurrentUser();
    const { username, userId } = currentUser;
    const attrs = await fetchUserAttributes();

    const customRole =
      attrs["custom:role"] || (attrs as any).customRole || undefined;
    const mspIdRaw = attrs["custom:mspId"] || (attrs as any).mspId;
    const mspId =
      mspIdRaw != null && mspIdRaw !== "" ? Number(mspIdRaw) : undefined;

    const name =
      attrs.name ||
      [attrs.given_name, attrs.family_name].filter(Boolean).join(" ") ||
      attrs.preferred_username ||
      username;

    return { userId, username, name, email: attrs.email, customRole, mspId };
  } catch (error) {
    console.error("Error fetching user:", error);
    return null;
  }
};
